(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const footer = document.querySelector('[data-site-footer]');
    if (!footer) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          footer.classList.add('is-inview');
          io.unobserve(footer);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
    );
    io.observe(footer);
  });
})();
